<script setup>
import { reactive, ref, onMounted, computed } from 'vue';
import { useEventsStore } from '@/stores/events';

const eventsStore = useEventsStore();

// Preload featured event from #annual-conference-cta div
const container = document.getElementById('annual-conference-cta');
const rawData = container?.dataset?.event ?? 'null';

let initialEvent = null;

try {
	initialEvent = JSON.parse(rawData);
} catch (error) {
	console.error('Failed to parse preloaded events JSON:', error);
}

const fetched = computed(() => {
	return eventsStore.conferenceFetched;
});

const event = computed(() => {
	if (fetched.value) {
		return eventsStore.conference;
	}

	return initialEvent ? initialEvent : null;
});

const fetchConference = async() => {
	try {
		const response = await axios.get(window.portal.conference_url);

		eventsStore.setConference(response.data);
	}
	catch (error) {

	} finally {

	}
}

//Fetch every time and update store
fetchConference();

const portal = ref(window.portal);
const labels = ref(window.portal.labels);
const placeholder = ref(window.portal.placeholder);

</script>

<template>
	<div class="wp-block-group alignfull is-layout-constrained" style="margin-left: var(--wp--preset--spacing--50); margin-right: var(--wp--preset--spacing--50); margin-top: var(--wp--preset--spacing--70); margin-bottom: var(--wp--preset--spacing--70);" v-if="event">
		<div class="wp-block-media-text alignwide is-stacked-on-mobile">
			<figure class="wp-block-media-text__media">
				<img :src="event.image_uri ? event.image_uri : placeholder"/>
			</figure>

			<div class="wp-block-media-text__content">
				<div class="wp-block-group is-layout-flow">
					<h2 class="is-style-eyebrow" v-html="labels.annual_conference"></h2>
					<h3 class="has-h-2-font-size" style="margin-top: var(--wp--preset--spacing--20);" v-html="labels.join_us"></h3>
					<p v-if="event.teaser" v-html="event.teaser"></p>
					<div class="wp-block-buttons" style="margin-top: var(--wp--preset--spacing--40);">
						<div class="wp-block-button">
							<a class="wp-block-button__link" :href="eventsStore.getEventUrl(event.key)" v-html="labels.learn_more"></a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
